(()=>{
    // Follow on Shop Button
    document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver(() => {
        const shopFollow = document.querySelector("shop-follow-button");

        if (shopFollow && shopFollow.shadowRoot) {
            const btn = shopFollow.shadowRoot.querySelector("button");
            if (btn) {

                const text = btn.querySelector(".text-button-large");

                if(text) text.style.color = "#F2F7F7";
                observer.disconnect();
            }
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
    });
})()